export default "https://legacy.eskolare-development.com/images/subscriptions-empty.png";